import { inject } from '@angular/core';
import { patchState, signalStore, withComputed, withHooks, withMethods, withState } from '@ngrx/signals';
import { SystemAnnouncementService, ToastService } from '@raptor-fe/services';
import { pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { SystemAnnouncement, SystemAnnouncementType } from '@raptor-fe/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';

export interface SystemAnnouncementsWidgetState {
    announcements: SystemAnnouncement[];
    isLoading: boolean;
}

export const SystemAnnouncementsWidgetStore = signalStore(
    withState<SystemAnnouncementsWidgetState>({
        announcements: [],
        isLoading: false,
    }),
    withComputed((store) => ({
        whatsNewItems: () => store.announcements().filter((i) => i.type === SystemAnnouncementType.WhatIsNew),
        announcementItems: () => store.announcements().filter((i) => i.type === SystemAnnouncementType.Announcement),
    })),
    withMethods((store, service = inject(SystemAnnouncementService), toastService = inject(ToastService)) => ({
        // Fetch Announcements
        fetchAnnouncements: rxMethod<void>(
            pipe(
                tap(() => patchState(store, { isLoading: true })),
                switchMap(() =>
                    service.getActive().pipe(
                        tapResponse({
                            next: (announcements) => {
                                patchState(store, { announcements });
                            },
                            error: async () => {
                                await toastService.showError('Error fetching announcements.');
                            },
                            finalize: () => patchState(store, { isLoading: false }),
                        }),
                    ),
                ),
            ),
        ),
    })),
    withHooks({
        onInit(store) {
            store.fetchAnnouncements();
        },
    }),
);
